import React from "react";

const TokenListItem = ({ tokenName, tokenValue }) => {
  return (
    <div className="flex gap-[2px] items-center">
      <p className="text-sm leading-[21px] text-lightBlack dark:text-lightWhite">
        {tokenName}
      </p>
      <p className="text-sm leading-[21px] text-deepBlue">{tokenValue}</p>
    </div>
  );
};

export default TokenListItem;
